import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import { LoginScreen } from './auth/LoginScreen';
import { TabBar } from './components/TabBar';
import { AccountsScreen } from './screens/AccountsScreen';
import { DashboardScreen } from './screens/DashboardScreen';
import { EntryScreen } from './screens/EntryScreen';
import { FixedScreen } from './screens/FixedScreen';
import { SavingsScreen } from './screens/SavingsScreen';
import { SettingsScreen } from './screens/SettingsScreen';
import { TransactionsScreen } from './screens/TransactionsScreen';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Un budget ne bouge pas à la seconde ; inutile de refaire la requête
      // au moindre retour sur l'onglet.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

/** Les écrans à onglets réservent la place de la barre du bas. */
function TabbedLayout() {
  return (
    <div className="safe-top mx-auto max-w-md pb-28">
      <Outlet />
      <TabBar />
    </div>
  );
}

function AuthenticatedApp() {
  return (
    <Routes>
      <Route element={<TabbedLayout />}>
        <Route path="/" element={<DashboardScreen />} />
        <Route path="/ecritures" element={<TransactionsScreen />} />
        <Route path="/epargne" element={<SavingsScreen />} />
        <Route path="/fixes" element={<FixedScreen />} />
        <Route path="/comptes" element={<AccountsScreen />} />
        <Route path="/reglages" element={<SettingsScreen />} />
      </Route>
      {/* Plein écran : la saisie ne doit rien avoir autour d'elle. */}
      <Route
        path="/saisie"
        element={
          <div className="safe-top mx-auto max-w-md">
            <EntryScreen />
          </div>
        }
      />
      <Route path="*" element={<DashboardScreen />} />
    </Routes>
  );
}

function Gate() {
  const { status } = useAuth();

  if (status === 'checking') {
    return <div className="flex min-h-dvh items-center justify-center text-ink-muted">…</div>;
  }
  return status === 'authenticated' ? <AuthenticatedApp /> : <LoginScreen />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Gate />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
